// @flow
import * as React from 'react'

import DraggableFileUpload, {
  type Props as FileProps,
} from '../atoms/DraggableFileUpload'
import BaseField, { type Props as FieldProps } from './BaseField'

export type Props = FieldProps & FileProps

function DraggableFileUploadField({
  id,
  name,
  multiple,
  accept,
  showUploadList,
  onChange,
  onError,
  disabled,
  files,
  onDrop,
  allowDownload,
  handleDownload,
  ...rest
}: Props): React.Node {
  return (
    <BaseField {...rest}>
      <div className="mt-1" {...rest}>
        <DraggableFileUpload
          accept={accept}
          allowDownload={allowDownload}
          disabled={disabled}
          files={files}
          handleDownload={handleDownload}
          id={id}
          multiple={multiple}
          name={name}
          onChange={onChange}
          onDrop={onDrop}
          onError={onError}
          showUploadList={showUploadList}
          {...rest}
        />
      </div>
    </BaseField>
  )
}

export default DraggableFileUploadField
